import { Component, Input, ViewEncapsulation } from "@angular/core";
import { NbComponentStatus, NbDialogRef } from "@nebular/theme";

@Component({
    selector: "kno2-confirm-or-deny",
    template: `
        <nb-card>
            <nb-card-header>{{ header }}</nb-card-header>
            <nb-card-body>
                @if (alert) {
                    <kno2-alert
                        [message]="alert.message"
                        [isDialog]="false"
                        [status]="alert.status"
                        [closable]="alert.closable"
                        class="mb-2"></kno2-alert>
                }
                @if (subtitle) {
                    <p>{{ subtitle }}</p>
                }
                <br />
                <p>
                    <b [innerHTML]="body"></b>
                </p>
            </nb-card-body>
            <nb-card-footer>
                <button
                    [disabled]="isSubmitting"
                    [nbSpinner]="isSubmitting"
                    (click)="confirm()"
                    nbButton
                    size="small"
                    class="mr-2"
                    [status]="confirmButtonStatus || 'danger'">
                    {{ confirmButtonText || "Confirm" }}
                </button>
                <button
                    (click)="cancelEvent()"
                    nbButton
                    size="small"
                    kno2AutoFocus>
                    Cancel
                </button>
            </nb-card-footer>
        </nb-card>
    `,
    styleUrls: ["./confirm-or-deny.component.scss"],
    encapsulation: ViewEncapsulation.Emulated,
    standalone: false
})
export class ConfirmOrDenyComponent {
    public isSubmitting = false;
    @Input() public header: string;
    @Input() public subtitle?: string;
    @Input() public alert?: { status: NbComponentStatus; message: string; closable: boolean };
    @Input() public body: string;
    @Input() public confirmButtonText: string;
    @Input() public confirmButtonStatus: string;
    @Input() public confirmEvent: (isSubmitting: boolean) => void;
    @Input() public cancelEvent: () => void;

    constructor(private dialogRef: NbDialogRef<any>) {}

    public confirm(): void {
        this.isSubmitting = true;
        this.confirmEvent(this.isSubmitting);
    }
}
